import React, { useRef, useEffect, useState, useContext } from "react";
import { onCADSubmit, getCADData, useCADDataHook } from "./ExportLayersVM";
// import Select from "react-select";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { makeKML } from "../export-kml/ExportKmlVM";
import exportTableToCSV from "./exportCSV";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import exportToMailingLabels from "./ExportMailingLabels";
import { OCLandInsightsContext } from "../../../hooks/context/OcLandInsightsContext";
import { table } from "console";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";

const ExportLayersWidget = ({ view, activeWidget }) => {
  const exportLayerWidgetDiv = useRef(null);
  const [visible, setVisible] = useState(false);
  const [disable, setDisable] = useState(true);
  const [showText, setShowText] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);

  const [designAutomationId, setDesignAutomationId] = useState();
  const [designAutomationConnect, setDesignAutomationConnect] = useState(null);
  const [designAutomationUrl, setDesignAutomationUrl] = useState();
  const [appError, setAppError] = useState("");
  const [selected, setSelected] = useState("");
  const [reConnect, setReConnect] = useState(false);
  const payload: any = useCADDataHook();
  const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);

  useEffect(() => {
    if (activeWidget === "exportTool") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }

  useEffect(() => {
    const designAutomation = new HubConnectionBuilder()
      .withUrl(
        "https://ocma-staging-api-c3h5cedhgef7h0ey.westus-01.azurewebsites.net/api/signalr/designautomation"
      )
      .withAutomaticReconnect()
      .build();
    console.log("get desdesignAutomation from HubBuilder: ", designAutomation);
    setDesignAutomationConnect(designAutomation);
  }, [reConnect]);

  useEffect(() => {
    if (designAutomationConnect) {
      console.log("designAutomationConnect changed");

      designAutomationConnect
        .start()
        .then(() => {
          designAutomationConnect.invoke("getConnectionId").then((id) => {
            setDesignAutomationId(id);
          });

          designAutomationConnect.on("downloadResult", (url) => {
            // Add code here to handle the url to download automatically or
            // display the url to the user for them to download.
            var link = document.createElement("a");
            link.href = url;
            link.click();
            setDesignAutomationUrl(url);
            setShowSuccess(true);
            setShowText(false);
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [designAutomationConnect]);

  const reconnectionTimeStamp = () => {
    // Get the current time
    const currentTime = new Date().getTime();

    // Check if timestamp already exist
    const storedTimestamp = localStorage.getItem("connectionSignalRTimestamp");
    if (storedTimestamp === null || storedTimestamp === undefined) {
      // Set the timestamp in localStorage
      localStorage.setItem(
        "connectionSignalRTimestamp",
        currentTime.toString()
      );
    }

    // Check if the stored timestamp has exceeded 20 minutes
    const timedifference = currentTime - parseInt(storedTimestamp);
    const hasExceededTime = timedifference >= 20 * 60 * 1000;
    if (hasExceededTime) {
      // Reset the timestamp signal r connection
      console.log("Resetting timestamp for signal r");
      localStorage.setItem(
        "connectionSignalRTimestamp",
        currentTime.toString()
      );

      // Trigger reconnection
      if (reConnect === true) {
        setReConnect(false);
      } else {
        setReConnect(true);
      }
    }
  };

  const ExportData = (selectedOption) => {
    setShowSuccess(false);
    setShowText(true);
    let doneDowload = false;

    if (selectedOption === "GenericDWG") {
      reconnectionTimeStamp();

      const cadData = getCADData(payload);
      onCADSubmit(cadData, "ocpwgeneric", designAutomationId);
    }

    if (selectedOption === "OCSurveyCRDWG") {
      reconnectionTimeStamp();

      const cadData = getCADData(payload);
      onCADSubmit(cadData, "ocpwsurvey", designAutomationId);
    }

    if (selectedOption === "OCSurveyBoundaryDWG") {
      reconnectionTimeStamp();

      const cadData = getCADData(payload);
      onCADSubmit(cadData, "ocpwsurveyboundary", designAutomationId);
    }

    if (selectedOption === "KML") {
      doneDowload = makeKML(view);
    }

    if (selectedOption === "CSV") {
      payload.forEach((tableObject) => {
        const { layerName, popupFields, features } = tableObject;
        doneDowload = exportTableToCSV(layerName, popupFields, features);
      });
    }

    if (selectedOption === "Mailing Labels") {
      let tableObjectList = [];
      payload.forEach((tableObject) => {
        const { layerName, popupFields, features } = tableObject;
        tableObjectList.push(tableObject);
      });
      let tableObjectFeature = tableObjectList.filter(
        (feature) =>
          feature.features[0].parentCustomParameters.OCLandInsightsID ===
          ocLandInsightsDictionaryCtx.data.parcels
      );
      if (tableObjectFeature.length > 0) {
        let mailingLabelFeature = tableObjectFeature[0];
        doneDowload = exportToMailingLabels(mailingLabelFeature, view);
      } else {
        setShowFail(true);
        setShowText(false);
      }
    }

    if (doneDowload) {
      setShowSuccess(true);
      setShowText(false);
    }

    setTimeout(() => {
      setShowSuccess(false);
    }, 10000);
  };
  // ===============================================================================================

  const exportFormat = [
    // { value: "File_Geodatabase", label: "ESRI File Geodatabase (.gdb)" },
    // { value: "Shapefile", label: "ESRI Shapefile (.shp)"},
    { value: "CSV", label: "CSV" },
    { value: "GenericDWG", label: "DWG" },
    { value: "OCSurveyCRDWG", label: "OC Survey CR DWG" },
    { value: "OCSurveyBoundaryDWG", label: "OC Survey Boundary DWG" },
    { value: "KML", label: "KML" },
    { value: "Mailing Labels", label: "Mailing Labels" },
  ];
  const menuItems = exportFormat.map((item) => {
    return (
      <MenuItem key={`export-menuItem-${item.value}`} value={item.value}>
        {item.label}
      </MenuItem>
    );
  });

  return (
    <>
      <div ref={exportLayerWidgetDiv} style={style}>
        <Stack direction="row" spacing={2}>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="export-select-label">Export file</InputLabel>
            <Select
              labelId="export-select-label"
              label="export"
              value={selected}
              onChange={(e) => {
                setDisable(e.target.value === "");
                setSelected(e.target.value);
              }}
            >
              {menuItems}
            </Select>
          </FormControl>
          <Button
            title="export selection"
            variant="contained"
            color="secondary"
            disabled={disable}
            onClick={async (e) => {
              e.preventDefault();
              await ExportData(selected);
            }}
          >
            Export
          </Button>
        </Stack>
        <div>
          <div style={{ width: "100%" }}>
            {showText ? (
              <Alert icon={<CircularProgress />} severity="info">
                Downloading Data...
              </Alert>
            ) : null}
          </div>
          <div style={{ width: "100%" }}>
            {showSuccess ? (
              <Alert severity="success">Download Success</Alert>
            ) : null}
          </div>
          <div style={{ width: "100%" }}>
            {showFail ? (
              <Alert severity="warning">
                Please select Parcels for Mailing Labels
              </Alert>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
export default ExportLayersWidget;
